module.exports = __webpack_public_path__ + "img/image18.68d96db0.png";